import apiSvc from '../../../core/services/apiSvc';
import validSvc from '../../../core/validSvc';
import { ngDelegate } from '../../../core/services/ng.delegate';

const GET_BI_PURL = 'security/tableau/auth';

type BiPurlVM = {
    ReportUrl: string;
};

const getBiViewPurl = async (claim: string): Promise<string> => {
    // params
    if (!validSvc.isText(claim)) {
        throw new Error('biRepo.getBiViewPurl, claim required');
    }
    const req = {
        Params: {
            ReportClaim: claim,
        },
    };
    const r: BiPurlVM = (await apiSvc.getEntity(GET_BI_PURL, req)) as BiPurlVM;

    if (!validSvc.isText(r.ReportUrl)) {
        ngDelegate.warn('BI Url Missing', 'biRepo.getBiViewPurl', '200', 'claim: ' + claim);
        throw null;
    }
    return r.ReportUrl;
};

// SIGNATURE
const biRepo = {
    getBiViewPurl: getBiViewPurl,
};
export default biRepo;
